import type { useProductPlaceholderModel } from '@/components/shared/product-placeholder/product-placeholder.model'

type ProductPlaceholderViewProps = ReturnType<typeof useProductPlaceholderModel>

export function ProductPlaceholderView({
  name,
  initial,
  ariaLabel,
}: ProductPlaceholderViewProps) {
  return (
    <div className="fz-product-placeholder" role="img" aria-label={ariaLabel}>
      <span className="fz-product-placeholder__initial" aria-hidden="true">
        {initial}
      </span>
      <span className="fz-product-placeholder__name">{name}</span>
    </div>
  )
}
